<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" :val="headerTitle"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section class="hr pt25 mb25">
          <div class="btnArea mt0">
            <button type="button" class="btn_s m" @click="changeInstallinfoInsertPop = true">이전설치 신청</button>
          </div>
          <p class="txtList_remark notice">
            이전설치는 설치환경에 따라 설치가 불가할 수 있습니다. 자세한 설치가능여부는 기사님 방문시 확인 가능합니다.
          </p>
        </section>

        <section class="hr">
          <div class="titArea">
            <h2 class="titH4">
              이전설치 신청현황
              <span class="normal">({{ moveList.length }})</span>
            </h2>
          </div>

          <div v-if="moveList.length > 0">
            <ul class="accoList req">
              <li v-for="(value, key) in moveList" v-bind:key="key">
                <div class="accoHead">
                  <ul class="infoList req">
                    <li class="info">
                      <span class="item pointC1">{{ value.statusName }}</span>
                    </li>
                    <li>
                      <span class="item">신청상품</span>
                      <span class="val pointC7">{{ value.productName }}[{{ value.orderId }}]</span>
                    </li>
                    <li>
                      <span class="item">철거희망일</span>
                      <span class="val">
                        <datepicker
                          :value="destoryDate[key]"
                          v-model="destoryDate[key]"
                          :disabled="value.canModify == 'N'"
                          :format="format"
                          :input-class="inputClass"
                          :language="lang"
                          :disabled-dates="selectDestoryDisalbledDate"
                          @selected="selectDestoryDate(key)"
                        ></datepicker>
                        <button
                          type="button"
                          class="links pointC1 as"
                          v-show="btnModifyDestoryDate[key]"
                          @click="modifyCheckHopeDate(key, 0, value.orderId, value.receiptId)"
                        >
                          변경
                        </button>
                      </span>
                    </li>
                    <li>
                      <span class="item">이전설치희망일</span>
                      <span class="val">
                        <datepicker
                          :value="visitHopeDate[key]"
                          v-model="visitHopeDate[key]"
                          :disabled="value.canModify == 'N'"
                          :format="format"
                          :input-class="inputClass"
                          :language="lang"
                          :disabled-dates="selectVisitHopeDisalbledDate"
                          @selected="selectVisitHopeDate(key)"
                        ></datepicker>
                        <button
                          type="button"
                          class="links pointC1 as"
                          v-show="btnModifyVisitHopeDate[key]"
                          @click="modifyCheckHopeDate(key, 1, value.orderId, value.receiptId)"
                        >
                          변경
                        </button>
                      </span>
                    </li>
                  </ul>
                </div>
                <div class="accoBody">
                  <ul class="infoList req">
                    <li>
                      <span class="item">철거지 주소</span>
                      <span class="val">{{ value.rtnAddrRoad + ' ' + value.rtnAddrRemark }}</span>
                    </li>
                    <li v-show="value.status === 'AMST0004'">
                      <span class="item">철거 완료일</span>
                      <span class="val">{{ value.rtnCompleteDate }}</span>
                    </li>
                    <li>
                      <span class="item">이전설치주소</span>
                      <span class="val">{{ value.istAddrRoad + ' ' + value.istAddrRemark }}</span>
                    </li>
                    <li v-show="value.status === 'AMST0004'">
                      <span class="item">이전설치완료일</span>
                      <span class="val">{{ value.istCompleteDate }}</span>
                    </li>
                    <li><p class="txtList_remark txtXS">취소는 콜센터(1670-0202)로 문의해주세요.</p></li>
                  </ul>
                </div>
                <button type="button" class="btnIco_acco accoBtn"><span>상세보기</span></button>
              </li>
            </ul>
          </div>
          <div class="resultMsg txtOnly" v-show="moveList.length == 0 && initFlag">
            <p class="copy">신청 내역이 없습니다.</p>
          </div>
        </section>

        <CommonBanner></CommonBanner>
      </div>
      <!-- content(e) -->

      <QuickMenu></QuickMenu>
      <MessagePop v-if="messagePop" @close="close">
        <p v-html="msg"></p>
      </MessagePop>
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
    <ChangeInstallinfoInsertPop v-if="changeInstallinfoInsertPop" @close="close" />
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import QuickMenu from '@/views/app/comm/QuickMenu';
import CommonBanner from '@/components/banner/CommonBanner';
import ChangeInstallinfoInsertPop from '@/views/app/mypage/install/ChangeInstallinfoInsertPop';
import $ from 'jquery';
import * as customjs from '@/../static/js/m.front.js';
import Datepicker from 'vuejs-datepicker';
import { ko } from 'vuejs-datepicker/dist/locale';
import moment from 'moment';
import MessagePop from '@/components/popup/MessagePop';
import JwtService from '@/common/jwt.service';

export default {
  name: 'changeInstallInfo',
  components: {
    QuickMenu,
    CommonBanner,
    ChangeInstallinfoInsertPop,
    Datepicker,
    MessagePop,
  },
  mounted() {
    if (JwtService.getUserInfo()) this.userId = JwtService.getUserInfo().userId;
    this.changeInstallinfoInit();
  },
  data: function() {
    return {
      headerTitle: '이전설치 신청',
      changeInstallinfoInsertPop: false,
      moveList: [],

      msg: '',
      messagePop: false,

      initFlag: false,

      addVisitHopeDate: new Date(),
      btnModifyVisitHopeDate: [], // 변경버튼 리스트
      visitHopeDate: [], // 방문 희망일
      visitHopeDateDisabled: [], // 방문 희망일 disabled

      btnModifyDestoryDate: [], // 철거 변경버튼 리스트
      destoryDate: [], // 철거 희망일
      destoryDateDisabled: [], // 철거 희망일 disabled
      format: 'yyyy - MM - dd',
      inputClass: 'ipt date notDel uiAct w75',
      //calendarClass: 'ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all',
      lang: ko,
      flag: true,
      selectVisitHopeDisalbledDate: {
        to: this.getSelectVisitHopeMinDate(),
        days: [6, 0],
      },
      addVisitHopeDisalbledDate: {
        to: this.getAddVisitHopeMinDate(),
        days: [6, 0],
      },
      selectDestoryDisalbledDate: {
        to: this.getSelectVisitHopeMinDate(),
        days: [6, 0],
      },
      addDestoryDisalbledDate: {
        to: this.getAddVisitHopeMinDate(),
        days: [6, 0],
      },
    };
  },
  computed: {},
  updated() {
    customjs.accoInit();
    customjs.iptInit();
  },
  methods: {
    changeInstallinfoInit: function() {
      ApiService.service('GET', '/service/auth/as/moveList')
        .then(({ data }) => {
          this.initFlag = true;
          if (data.isSucceed) {
            this.moveList = data.result;
            for (let i = 0; i < this.moveList.length; i++) {
              this.destoryDate.push(moment(this.moveList[i].rtnReqDate).format('yyyy-MM-DD'));
              this.visitHopeDate.push(moment(this.moveList[i].istReqDate).format('yyyy-MM-DD'));
            }
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
          this.moveList = [];
        });
    },
    getSelectVisitHopeMinDate: function() {
      let today = new Date();
      today.setDate(today.getDate());
      return today;
    },
    getAddVisitHopeMinDate: function() {
      let today = new Date();
      // today.setDate(today.getDate() - 1);
      return today;
    },
    selectVisitHopeDate(index) {
      this.$set(this.btnModifyVisitHopeDate, index, true);
    },
    selectDestoryDate(index) {
      this.$set(this.btnModifyDestoryDate, index, true);
    },
    // 방문 희망일 변경
    modifyCheckHopeDate(index, type, orderId, receiptId) {
      // console.log(receiptId);
      console.log(index + '/' + type + '/' + orderId);
      if (moment(this.visitHopeDate[index]).format('yyyyMMDD') < moment(this.destoryDate[index]).format('yyyyMMDD')) {
        if (type == 0) {
          this.msg = '철거 희망일은 이전설치 희망일 이전 날짜로 선택해주세요.';
        } else {
          this.msg = '이전설치 희망일은 철거 희망일 이후 날짜로 선택해주세요.';
        }

        this.messagePop = true;
        return false;
      }
      console.log(moment(this.visitHopeDate[index]).format('yyyyMMDD') > moment(this.destoryDate[index]).format('yyyyMMDD'));

      ApiService.service('PUT', '/service/auth/asMove/reqDate', {
        request: {
          orderId: orderId,
          asMoveTyp: type == '0' ? 'RQMA0034' : 'RQMA0151', // (철거: RQMA0034 / 설치: RQMA0151")
          receiptId: receiptId,
          userId: this.userId,
          reqDate: type == '0' ? moment(this.destoryDate[index]).format('yyyyMMDD') : moment(this.visitHopeDate[index]).format('yyyyMMDD'),
        },
        serviceType: 'app',
      })
        .then(({ data }) => {
          console.log(data);
          if (data.isSucceed) {
            if (type == '0') {
              this.msg = '철거희망일이 변경 완료되었습니다.';
              this.btnModifyDestoryDate[index] = false;
            } else {
              this.msg = '이전설치희망일이 변경 완료되었습니다.';
              this.btnModifyVisitHopeDate[index] = false;
            }

            this.messagePop = true;
          } else {
            this.msg = data.error;
            this.messagePop = true;
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    async close() {
      //this.changeInstallinfoInit();
      await ApiService.service('GET', '/service/auth/as/moveList')
        .then(({ data }) => {
          console.log(data);
          this.initFlag = true;
          if (data.isSucceed) {
            this.moveList = data.result;
            for (let i = 0; i < this.moveList.length; i++) {
              if (this.changeInstallinfoInsertPop) {
                this.$set(this.destoryDate, i, this.moveList[i].rtnReqDate);
                this.$set(this.visitHopeDate, i, this.moveList[i].istReqDate);
              }
            }
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
          this.moveList = [];
        });
      this.changeInstallinfoInsertPop = false;
      this.messagePop = false;
      $('body').removeClass('popOn');
    },
  },
  destroyed() {},
};
</script>
